import React, { Component } from "react";

// ── Error Boundary — catches render crashes & shows error instead of blank page ─
class ErrorBoundary extends Component {
  constructor(props) { super(props); this.state = { hasError: false, error: null }; }
  static getDerivedStateFromError(error) { return { hasError: true, error }; }
  componentDidCatch(error, info) { console.error("[ErrorBoundary]", error, info); }
  render() {
    if (this.state.hasError) {
      const msg = this.state.error ? String(this.state.error) : "Unknown error";
      return (
        <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",alignItems:"center",
          justifyContent:"center",background:"#F9F7F2",padding:32,fontFamily:"'Inter',sans-serif"}}>
          <div style={{maxWidth:560,width:"100%",background:"#fff",borderRadius:12,padding:"28px 32px",
            border:"1px solid rgba(220,38,38,0.25)",boxShadow:"0 4px 20px rgba(0,0,0,0.08)"}}>
            <div style={{fontSize:15,color:"#dc2626",marginBottom:12,fontWeight:600}}>⚠ 页面加载出错</div>
            <div style={{fontSize:12,color:"#666",fontFamily:"monospace",background:"#fef2f2",
              padding:"12px 14px",borderRadius:8,wordBreak:"break-all",lineHeight:1.7}}>{msg}</div>
            <button onClick={()=>window.location.reload()}
              style={{marginTop:18,padding:"8px 20px",background:"#064E3B",color:"#fff",border:"none",
                borderRadius:6,fontSize:13,cursor:"pointer",letterSpacing:".04em"}}>
              重新加载
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
